import { render, staticRenderFns } from "./vpIndex.vue?vue&type=template&id=6f077930&scoped=true"
import script from "./vpIndex.vue?vue&type=script&lang=js"
export * from "./vpIndex.vue?vue&type=script&lang=js"
import style0 from "./vpIndex.vue?vue&type=style&index=0&id=6f077930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f077930",
  null
  
)

export default component.exports